

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.load-more');
  if (!btn) return;

  const targetId = btn.getAttribute('data-target');
  const listing = document.getElementById(targetId);
  if (!listing) return;

  const step = parseInt(listing.getAttribute('data-step'), 10) || 0;
  if (step <= 0) return;

  const hiddenItems = listing.querySelectorAll('.listing-item.hidden');
  if (hiddenItems.length === 0) {
    btn.style.display = 'none';
    return;
  }

  // Nächste "step" Elemente einblenden
  for (let i = 0; i < Math.min(step, hiddenItems.length); i++) {
    hiddenItems[i].classList.remove('hidden');
  }

  // Button ausblenden, wenn nichts mehr übrig
  if (listing.querySelectorAll('.listing-item.hidden').length === 0) {
    btn.style.display = 'none';
  }
});
